import {Injectable} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {interval} from 'rxjs';
import {AppVersionService} from '../../management/app-version/app-version.service';

@Injectable({
  providedIn: 'root'
})
export class AppUpdatesService {

  constructor(private updates: SwUpdate,
              private appVersionService: AppVersionService) {
  }

  public startUpdateMonitor() {
    if (!this.updates.isEnabled) {
      return;
    }
    this.updates.available.subscribe(event => {
      console.log(event);
      console.log('current version is', event.current);
      console.log('available version is', event.available);
      this.appVersionService.newAppVersionAvailable(event);
    });
    this.updates.activated.subscribe(event => {
      console.log(event);
      console.log('old version was', event.previous);
      console.log('new version is', event.current);
    });
    interval(30 * 1000).subscribe(async () => {
      console.log('Timer fired, check for app updates');
      console.log('Worker status', this.updates.isEnabled);
      await this.updates.checkForUpdate();
      console.log('Update check done');
    });
  }
}
